<template>
  <!-- 管理员-教育机构信息添加 -->
  <div class="main-box-css">
    <div class="main-box">
      <!--标题-->
      <p class="box-title">{{ $t("institutionalInformation") }}</p>
      <div class="from">
        <!-- 第一行-->
        <div class="from-long-input">
          <div class="long-box">
            <div class="input-title">
              {{ $t("selectEducationalAdministrator") }}<span>*</span>
            </div>
            <div class="inline-box-dropdown">
              <el-dropdown @command="handleClick1">
                <span class="el-long-dropdown-link">
                  {{ dropdownOne }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in userTableData" :key="index" :command="index">
                    {{ item.userName }}
                  </el-dropdown-item>
                  <!--                  <el-dropdown-item command="2">管理员2</el-dropdown-item>-->
                  <!--                  <el-dropdown-item command="3">管理员3</el-dropdown-item>-->
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <!-- 第一行 -->
        <div class="from-one-input">
          <div class="one-box">
            <div class="one-box-title">
              {{ $t("institutionName") }}<span>*</span>
            </div>
            <div class="one-input-css">
              <el-input v-model="inputData1" :placeholder="elInputInstitutionName" @blur="inputData(1)" maxlength="100">
              </el-input>
            </div>
          </div>
        </div>
        <!-- 第二行 -->
        <div class="from-one-input">
          <div class="small-box">
            <div class="small-box-title">
              {{ $t("postCode") }}<span>*</span>
            </div>
            <div class="small-input-css">
              <el-input v-model="inputData2" :placeholder="elInputZipCode" @blur="inputData(2)" maxlength="20">
              </el-input>
            </div>
          </div>
          <div class="one-box">
            <div class="one-box-title">{{ $t("location") }}<span>*</span></div>
            <div class="one-input-css">
              <el-input v-model="inputData3" :placeholder="elInputLocation" @blur="inputData(3)" maxlength="255">
              </el-input>
            </div>
          </div>
        </div>
        <!-- 第三行 -->
        <div class="from-one-input">
          <div :class="disabled ? 'small-box-disabled ' : 'small-box'">
            <div class="small-box-title">
              {{ $t("institutionalAttributes") }}<span>*</span>
            </div>
            <div class="inline-box-dropdown">
              <el-dropdown :disabled="disabled" @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ this.op }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in TableData" :key="item.code" :command="item">
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div :class="disabled ? 'one-box-disabled ' : 'one-box'">
            <div class="one-box-title">{{ $t("hpOrSns") }}<span>*</span></div>
            <div class="one-input-css">
              <el-input v-model="inputData5" :placeholder="elInputHp" :disabled="disabled" @blur="inputData(4)"
                maxlength="255"></el-input>
            </div>
          </div>
        </div>
        <!-- 第四行 -->
        <div class="from-one-input">
          <div class="small-box">
            <div class="small-box-title">
              {{ $t("representativeName") }}<span>*</span>
            </div>
            <div class="small-input-css">
              <el-input v-model="inputData6" :placeholder="enterRepresentative" @blur="inputData(5)" maxlength="100">
              </el-input>
            </div>
          </div>
          <div class="one-box">
            <div class="one-box-title">
              {{ $t("institutionalNumber") }}<span>*</span>
            </div>
            <div class="one-input-css">
              <el-input v-model="inputData7" :placeholder="EnterPhoneNumber" @blur="inputData(6)" maxlength="20">
              </el-input>
            </div>
          </div>
        </div>
        <!-- 第五行 -->
        <div class="from-one-input">
          <div :class="disabled ? 'small-box-disabled ' : 'small-box'">
            <div class="small-box-title">
              {{ $t("numberStaff") }}<span>*</span>
            </div>
            <div class="inline-box-dropdown">
              <el-dropdown :disabled="disabled" @command="handleCommandTeacher">
                <span class="el-dropdown-link">
                  {{ this.opTeacher
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in teacherTableData" :key="item.code" :command="item">
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div :class="disabled ? 'one-box-disabled ' : 'one-box'">
            <div class="one-box-title">
              {{ $t("studentNumber") }}<span>*</span>
            </div>
            <div class="inline-box-dropdown">
              <el-dropdown :disabled="disabled" @command="handleCommandStudent">
                <span class="el-dropdown-link">
                  {{ this.opStudent
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in studentTableData" :key="item.code" :command="item">
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <!-- 第六行 -->
        <div class="form-text-area">
          <div class="text-area-box">
            <div class="one-box-title">
              {{ $t("institutionalInformationMain") }}<span>*</span>
            </div>
            <div class="text-area-input">
              <el-input type="textarea" :rows="2"
                :placeholder="institutionalPlaceholder" v-model="textarea">
              </el-input>
            </div>
          </div>
        </div>
        <!-- button部分 -->
        <div class="form-button">
          <button @click="handleAddInfo">{{ $t("login") }}</button>
        </div>
        <!-- 头像部分 -->
        <div class="Avatar">
          <div class="Avatar-img" @click="toGetImg" v-if="!imageUrl">
            <p class="Avatar-img-icon">
              <img src="./assets/Image_01.svg" alt="" />
            </p>
            <p class="Avatar-img-title">{{ $t("LogImage") }}</p>
          </div>
          <div class="Avatar-img" @click="toGetImg" v-if="imageUrl">
            <img :src="imageUrl" alt="" class="Avatar-img-main-css" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    queryEducationUser,
    educationInfoQuery,
    educationInsert,
    getUrlFromOSS
  } from "../../js/api";
  import AES from "../../js/AES";
  import axios from "axios";

  export default {
    name: "adminAddEducationalInstitutionInformation",
    components: {},
    data () {
      return {
        dropdownOne: "", //教育机关管理员下拉框
        dropdownTwo: "", //机关属性下拉框
        dropdownThree: "", //職員数下拉框
        dropdownFour: "", //学生人数下拉框
        imageUrl: "", //头像图片地址路径
        imgList: [],
        normal: require("./assets/Image_01.svg"),
        op: "",
        opTeacher: "",
        opStudent: "",
        inputData1: "", //機関名input
        inputData2: "", //郵便番号input
        inputData3: "", //所在地input
        inputData4: "", //代表者氏名input
        inputData5: "", //機関の電話番号input
        inputData6: "", //HP or SNSinput
        inputData7: "", //代表者氏名input
        inputData8: "", //機関の電話番号input
        inputData9: "", //HP or SNSinput
        textarea: "", //文本框内容
        disabled: false, //禁用状态
        lodePageData: {}, //上个页面传回的数据
        loadRole: "", //上个页面传回的角色标识
        userTableData: [],
        studentTableData: [],
        TableData: [],
        teacherTableData: [],
        urlImgInfo: "",
        avatarUrl: "",
        avatar: "",
        employeeNumber: "",
        studentsNumber: "",
        EducationAttributes: "",
        vc: "",
        userId:''
      };
    },
    created () {
      //获取当前语言的值
      this.language = window.localStorage.getItem("language");
      console.log("语言选择为" + window.localStorage.getItem("language"));
      console.log("页面语言选择为" + this.language);
      this.getLanguage();
      //生命周期，打开页面时调用
      this.onQueryEducationUser();
      this.jpstaffNumber();
    },
    computed: {
      elInputSearch () {
        return this.$t("ifRegisteredEnterName");
      }, //搜索部分的placeholder

      elInputInstitutionName () {
        return this.$t("forNewEnterContents");
      },

      elInputZipCode () {
        return this.$t("enterZipCode");
      },

      elInputLocation () {
        return this.$t("enterAddress");
      },

      elInputHp () {
        return this.$t("homepageEtc");
      },

      enterRepresentative () {
        return this.$t("enterRepresentative");
      },

      EnterPhoneNumber () {
        return this.$t("EnterPhoneNumber");
      },
      institutionalPlaceholder(){
      return this.$t("institutionalPlaceholder");
    },
    },
    destroyed () {
      window.removeEventListener("setItemEvent", this.languageChange, true);
    },
    mounted () {
      window.addEventListener("setItemEvent", this.languageChange, true);
    },
    methods: {
      //监听语言
      languageChange (e) {
        const that = this;
        console.log("------监听数据------");
        console.log(e);
        if (e.key && e.key == "language" && e.newValue) {
          that.language = e.newValue;
          this.onQueryEducationUser();
          this.jpstaffNumber();
        }
      },
      //获得语言
      getLanguage () {
        if (this.language === "CN") {
          this.employeeNumber = "employeeNumber";
          this.studentsNumber = "studentsNumber";
          this.EducationAttributes = "EducationAttributes";
        } else {
          this.employeeNumber = "jpemployeeNumber";
          this.studentsNumber = "jpstudentsNumber";
          this.EducationAttributes = "jpEducationAttributes";
        }
      },
      // input校验
      inputData (num) {
        var vc1 = /^.{1,99}$/;
        var vc2 = /^.{1,19}$/;
        var vc3 = /^.{1,254}$/;
        var vc4 = /^.{1,254}$/;
        var vc5 = /^.{1,99}$/;
        var vc6 = /^.{1,19}$/;

        if (num === 1) {
          if (vc1.test(this.inputData1)) {
          } else {
            this.$message({
              message: this.$t("warningEducationName"),
              type: "error"
            });
          }
        } else if (num === 2) {
          if (vc2.test(this.inputData2)) {
          } else {
            this.$message({
              message: this.$t("warningEducationPost"),
              type: "error"
            });
          }
        } else if (num === 3) {
          if (vc3 !== this.inputData3) {
          } else {
            this.$message({
              message: this.$t("warningEducationLocal"),
              type: "error"
            });
          }
        } else if (num === 4) {
          if (vc4.test(this.inputData5)) {
          } else {
            this.$message({
              message: this.$t("warningEducationSns"),
              type: "error"
            });
          }
        } else if (num === 5) {
          if (vc5.test(this.inputData5)) {
          } else {
            this.$message({
              message: this.$t("warningEducationRpName"),
              type: "error"
            });
          }
        } else if (num === 6) {
          if (vc6.test(this.inputData7)) {
          } else {
            this.$message({
              message: this.$t("warningEducationPhone"),
              type: "error"
            });
          }
        }
      },
      //图片回显
      getUrl (url) {
        console.log("url" + url);
        var fakeInfo = {
          message: url
        };
        getUrlFromOSS(fakeInfo)
          .then(res => {
            if (res.data.code === "200 OK") {
              console.log("图片回显接口1");
              console.log(res);
              const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
              console.log(aesFecInfo);
              this.imageUrl = aesFecInfo.message;
            } else {
              console.log(res);
            }
          })
          .catch(() => { });
      },
      //学生人数下拉框
      handleCommandStudent (e) {
        this.inputData9 = e.code;
        this.opStudent = e.name;
        console.log(e);
      },
      //老师下拉框
      handleCommandTeacher (e) {
        this.inputData8 = e.code;
        this.opTeacher = e.name;
        console.log(e);
      },
      //机关属性下拉框
      handleCommand (e) {
        this.inputData4 = e.code;
        this.op = e.name;
        console.log(e);
      },
      //获取下拉框选项
      jpstaffNumber () {
        var that = this;
        that.getLanguage();
        axios
          .get("/api/modules-parent/common/getDateItem", {
            params: {
              dataItem: that.employeeNumber
            },
            headers: {
              "content-type": "application/x-www-form-urlencoded",
              token: localStorage.getItem("token")
            }
          })
          .then(function (res) {
            if (res.data.code === "A0000") {
              console.log(res);
              const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
              that.teacherTableData = aesFecInfo.data;
              console.log(that.teacherTableData);
              that.jpstudentsNumber();
            } else {
              console.log(res.data);
              that.$message.error(res.data.message);
              that.jpstudentsNumber();
            }
          })
          .catch(res => {
            console.log(res);
          });
      },
      //学生下拉框获取
      jpstudentsNumber () {
        var that = this;
        that.getLanguage();
        axios
          .get("/api/modules-parent/common/getDateItem", {
            params: {
              dataItem: that.studentsNumber
            },
            headers: {
              "content-type": "application/x-www-form-urlencoded",
              token: localStorage.getItem("token")
            }
          })
          .then(function (res) {
            if (res.data.code === "A0000") {
              console.log(res);
              const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
              that.studentTableData = aesFecInfo.data;
              console.log(that.studentTableData);
              that.jpEducationAttributes();
            } else {
              console.log(res.data);
              that.$message.error(res.data.message);
              that.jpEducationAttributes();
            }
          })
          .catch(res => {
            console.log(res);
          });
      },
      //机构属性下拉框获取
      jpEducationAttributes () {
        var that = this;
        that.getLanguage();
        axios
          .get("/api/modules-parent/common/getDateItem", {
            params: {
              dataItem: that.EducationAttributes
            },
            headers: {
              "content-type": "application/x-www-form-urlencoded",
              token: localStorage.getItem("token")
            }
          })
          .then(function (res) {
            if (res.data.code === "A0000") {
              console.log(res);
              const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
              that.TableData = aesFecInfo.data;
              console.log(that.TableData);
              var userInfo = localStorage.getItem("userInfo");
              const userinfo = JSON.parse(AES.decrypt(userInfo));
              var status = userinfo.userStatus;
              if (status === 0) {
                that.select();
              } else {
                that.selects();
              }
            } else {
              console.log(res.data);
              that.$message.error(res.data.message);
              var userInfo = localStorage.getItem("userInfo");
              const userinfo = JSON.parse(AES.decrypt(userInfo));
              var status = userinfo.userStatus;
              if (status === 0) {
                that.select();
              } else {
                that.selects();
              }
            }
          })
          .catch(res => {
            console.log(res);
          });
      },
      //上传图片
      toGetImg () {
        let inputElement = null;
        if (inputElement === null) {
          // 生成文件上传的控件
          inputElement = document.createElement("input");
          inputElement.setAttribute("type", "file");
          inputElement.style.display = "none";

          if (window.addEventListener) {
            inputElement.addEventListener("change", this.uploadFile, false);
          } else {
            inputElement.attachEvent("onchange", this.uploadFile);
          }
          document.body.appendChild(inputElement);
        }
        inputElement.click();
      },
      uploadFile (el) {
        if (el && el.target && el.target.files && el.target.files.length > 0) {
          console.log(el);
          const files = el.target.files[0];
          const isLt2M = files.size / 1024 / 1024 < 2;
          const size = files.size / 1024 / 1024;
          console.log(size);
          // 判断上传文件的大小
          if (!isLt2M) {
            this.$message.error(this.$t("imageSize"));
          } else if (files.type.indexOf("image") === -1) {
            //如果不是图片格式
            // this.$dialog.toast({ mes: '请选择图片文件' });
            this.$message.error(this.$t("selectImage"));
          } else {
            const that = this;
            const reader = new FileReader(); // 创建读取文件对象
            reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
            reader.onload = function () {
              // 文件读取完成后
              // 读取完成后，将结果赋值给img的src
              that.imageUrl = this.result;
              console.log(this.result);
              // 数据传到后台
              const formData = new FormData();
              formData.append("file", files); // 可以传到后台的数据
              console.log(formData.get("file"));
              axios
                // /modules-parent/upload/uploadPictureToOSS
                .post("/api/modules-parent/upload/uploadPictureToOSS", formData, {
                  headers: {
                    //头部参数
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("token")
                  }
                })
                .then(function (res) {
                  //请求成功
                  if (res.data.code === "200 OK") {
                    console.log("-----上传图片参数-----");
                    console.log(res);
                    const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
                    console.log(aesFecInfo);
                    that.avatar = aesFecInfo.path;
                    that.avatarUrl = aesFecInfo.url;
                    console.log("显示地址");
                    console.log(that.avatar);
                    console.log(that.avatarUrl);
                  }
                })
                .catch(function (error) {
                  //请求失败
                  console.log(error);
                });
            };
          }
        }
      },

      handleClick1 (command) {
        // this.$message('click on item' + command)
        this.dropdownOne = this.userTableData[command].userName;
        this.userId=this.userTableData[command].userId
        console.log( this.userId)
        // this.$message('click on item' + this.dropdownOne)
      },

      // 查询所有未绑定教育机构的用户 list
      onQueryEducationUser () {
        const fakeInfo = {};
        queryEducationUser(fakeInfo)
          .then(res => {
            console.log("---查询所有未绑定教育机构的用户列表信息----");
            console.log(res);
            if (res.data.code === "A0000") {
              const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
              console.log(aesFecInfo);
              this.userTableData = aesFecInfo.data;
            }
          })
          .catch(res => {
            console.log("----查询所有未绑定教育机构的用户列表信息失败----");
            console.log(res);
          });
      },

      handleAddInfo () {
        console.log(12121)
        if (this.inputData1 !== '' &&
          this.inputData2 !== '' &&
          this.inputData3 !== '' &&
          this.inputData4 !== '' &&
          this.inputData5 !== '' &&
          this.inputData6 !== '' &&
          this.inputData7 !== '' &&
          this.inputData8 !== '' &&
          this.inputData9 !== '' && this.avatar != '') {

        var userInfo = localStorage.getItem("userInfo");
        const userinfo = JSON.parse(AES.decrypt(userInfo));
        console.log(userInfo)
        var fakeInfo = {
          educationName: this.inputData1,
          address: this.inputData3,
          attributes: this.inputData4,
          hpOrSns: this.inputData5,
          introduction: this.textarea,
          legalPerson: this.inputData6,
          postNumber: this.inputData2,
          studentNumber: this.inputData9,
          teacherNumber: this.inputData8,
          telephone: this.inputData7,
          avatarAddress: this.avatar,
          userId: this.userId,
          userName: this.dropdownOne
        };
        educationInsert(fakeInfo)
          .then(res => {
            console.log("教育机构信息新增接口数据:", res);
            console.log(fakeInfo);

            if (res.data.code === "A0000") {
              console.log(res);
              const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
              console.log(aesFecInfo);
              this.$message({
                message: AES.decrypt(res.data.data),
                type: "success"
              });
              this.$router.push({
                path: "/administratorViewEducationalList"
              });
            } else {
              console.log(res);
              this.$message.error(res.data.message);
            }
          })
          .catch(res => {
            console.log("新增教育机构信息接口数据异常:", res);
          });
        }else{
          this.$message.error(this.$t('dataEmpty'));
        }
      }
    }
  };
</script>
<style scoped>
  .main-box-css {
    width: 100%;
    height: 100%;
  }

  .main-css {
    width: 100%;
    height: 100%;
    background: #fff;
    padding: 35px 0;
    box-sizing: border-box;
  }

  .main-box {
    /* height: 100%; */
    width: 700px;
    margin: auto;
    position: relative;
    padding-bottom: 70px;
  }

  .box-title {
    width: 100%;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 34px;
    height: 34px;
    color: #686868;
    text-align: center;
    margin-bottom: 50px;
    margin-top: 24px;
  }

  .search {
    height: 35px;
    padding: 0 40px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
  }

  .from-long-input {
    height: 50px;
    padding: 0 0 0 40px;
    box-sizing: border-box;
    margin-top: 20px;
    display: flex;
  }

  .long-box {
    width: 640px;
    height: 44px;
    background: #ffffff;
    border: 2px solid #51abff;
    box-sizing: border-box;
    border-radius: 8px;
    position: relative;
  }

  .from-two-input {
    height: 50px;
    padding: 0 0 0 40px;
    box-sizing: border-box;
    margin-top: 30px;
    display: flex;
  }

  .two-box {
    width: 416px;
    height: 44px;
    background: #ffffff;
    border: 2px solid #51abff;
    box-sizing: border-box;
    border-radius: 8px;
    position: relative;
  }

  .from-one-input {
    height: 50px;
    padding: 0 0 0 40px;
    box-sizing: border-box;
    margin-top: 20px;
    display: flex;
  }

  .one-box {
    width: 416px;
    height: 44px;
    background: #ffffff;
    border: 2px solid #51abff;
    box-sizing: border-box;
    border-radius: 8px;
    position: relative;
  }

  .input-title {
    height: 24px;
    line-height: 24px;
    padding: 0 5px;
    box-sizing: border-box;
    position: absolute;
    top: -12px;
    left: 15px;
    background: #fff;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #51abff;
    z-index: 20;
  }

  .input-title span {
    color: #da1414;
  }

  .one-box-title {
    height: 24px;
    line-height: 24px;
    padding: 0 5px;
    box-sizing: border-box;
    position: absolute;
    top: -12px;
    left: 15px;
    background: #fff;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #51abff;
    z-index: 20;
  }

  .one-box-title span {
    color: #da1414;
  }

  .one-input-css /deep/ .el-input {
    width: 400px;
    height: 40px;
    margin-left: 5px;
  }

  .one-input-css /deep/ .el-input__inner {
    border: 1px solid transparent;
  }

  .small-box {
    width: 200px;
    height: 44px;
    background: #ffffff;
    border: 2px solid #51abff;
    box-sizing: border-box;
    border-radius: 8px;
    position: relative;
    margin-right: 20px;
  }

  .small-box-title {
    height: 24px;
    line-height: 24px;
    padding: 0 5px;
    box-sizing: border-box;
    position: absolute;
    top: -12px;
    left: 15px;
    background: #fff;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #51abff;
    z-index: 20;
  }

  .small-box-title span {
    color: #da1414;
  }

  .small-input-css /deep/ .el-input {
    width: 180px;
    height: 40px;
    /* margin-left: 5px; */
  }

  .small-input-css /deep/ .el-input__inner {
    border: 1px solid transparent;
  }

  .inline-box-dropdown {
    height: 40px;
    line-height: 45px;
    overflow: hidden;
  }

  .el-long-dropdown-link {
    width: 620px;
    display: inline-block;
    padding: 0 0 0 15px;
    box-sizing: border-box;
  }

  .el-dropdown-link {
    width: 180px;
    display: inline-block;
    padding: 0 0 0 15px;
    box-sizing: border-box;
  }

  .inline-box-dropdown i {
    float: right;
    margin-top: 15px;
    font-weight: 700;
  }

  .form-text-area {
    height: 178px;
    padding: 0 0 0 40px;
    box-sizing: border-box;
    margin-top: 20px;
  }

  .text-area-box {
    width: 640px;
    height: 178px;
    background: #ffffff;
    border: 2px solid #51abff;
    box-sizing: border-box;
    border-radius: 8px;
    position: relative;
  }

  .text-area-input {
    margin-top: 10px;
  }

  .text-area-input /deep/ .el-textarea__inner {
    border: 1px solid transparent;
    height: 160px;
  }

  .form-button {
    text-align: center;
    margin-top: 37px;
  }

  .form-button button {
    height: 40px;
    line-height: 40px;
    width: 150px;
    background: #fc630c;
    border-radius: 8px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
  }

  .Avatar {
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 128px;
    right: 75px;
  }

  .Avatar-img {
    width: 90px;
    height: 90px;
    background: #51abff;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    align-items: center;
    overflow: hidden;
  }

  .Avatar-img-icon {
    margin-top: 15px;
  }

  .Avatar-img-title {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #ffffff;
  }

  .Avatar-img .Avatar-img-main-css {
    width: 90px;
    height: 90px;
  }

  .one-box .inline-box-dropdown {
    line-height: 44px;
    height: 44px;
    overflow: hidden;
  }

  .one-box .el-dropdown-link {
    width: 400px;
    display: inline-block;
    padding: 0 0 0 15px;
    box-sizing: border-box;
  }

  .one-box .inline-box-dropdown i {
    float: right;
    margin-top: 15px;
    font-weight: 700;
  }
</style>


// WEBPACK FOOTER //
// src/pages/adminAddEducationalInstitutionInformation/index.vue